/*!
    * @product/scmp-sdk 1.1.11
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-MBV6PK5K.js.map
